import type { RootState } from '@app/store/store';

export const selectCountries = (state: RootState) => state.countries.dictionary;
